import {Directive, ElementRef, inject, input, OnInit} from '@angular/core';
import {combineLatest, fromEvent, merge} from 'rxjs';
import {distinctUntilChanged, filter, map, pairwise} from 'rxjs/operators';
import {AutoUnsubscribe} from 'src/app/decorators/auto-unsubscribe.decorator';
import {SUBSCRIPTIONS} from '../utils/constants';
import {toObservable} from '@angular/core/rxjs-interop';

@Directive({
  selector: '[reapplyFocus]',
})
@AutoUnsubscribe()
export class ReapplyFocusDirective implements OnInit {
  updateFocus = input.required<boolean>();
  el = inject(ElementRef);

  keypressEvent$ = fromEvent<KeyboardEvent>(this.el.nativeElement, 'keypress');
  focusinEvent$ = fromEvent<FocusEvent>(this.el.nativeElement, 'focusin');

  loadingEnd$ = toObservable(this.updateFocus).pipe(
    distinctUntilChanged(),
    pairwise(),
    filter(([prev, curr]) => prev === true && curr === false),
  );

  events$ = merge(this.keypressEvent$, this.focusinEvent$);

  focusByEvents$ = combineLatest([this.events$, this.loadingEnd$]).pipe(
    map(([event]) => {
      const target = event.target as HTMLElement;
      return target.dataset.reapplyFocusId;
    }),
    filter(datasetId => !!datasetId),
  );

  ngOnInit(): void {
    this[SUBSCRIPTIONS].add(this.focusByEvents$.subscribe(datasetId => this.focusOnElementById(datasetId)));
    this[SUBSCRIPTIONS].add(this.loadingEnd$.subscribe());
  }

  focusOnElementById(datasetId: string) {
    const selector = `[data-reapply-focus-id="${datasetId}"]`;
    const element = this.el.nativeElement.querySelector(selector) as HTMLElement;
    element.focus();
  }
}
